var _Path, _Path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgWarningHorse(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fillRule: "evenodd"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M19.416 14.907L12.193 2.41C11.682 1.536 10.83 1 9.91 1s-1.77.536-2.282 1.41L4.702 7.473 3.78 9.08l-.446.773-2.927 5.054c-.51.884-.536 1.886-.082 2.68s1.345 1.27 2.364 1.27h14.446c1.02 0 1.905-.475 2.364-1.27s.43-1.796-.082-2.68z",
    fill: "#ffd902"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M19.416 14.907L12.193 2.41C11.682 1.536 10.83 1 9.91 1s-1.77.536-2.282 1.41L4.702 7.473 3.78 9.08l-.446.773-2.927 5.054c-.51.884-.536 1.886-.082 2.68s1.345 1.27 2.364 1.27h14.446c1.02 0 1.905-.475 2.364-1.27s.43-1.796-.082-2.68zm-2.282 2.107H2.688c-.754 0-1.07-.536-.686-1.186L9.225 3.332c.19-.327.438-.49.686-.49s.496.163.686.49l4.296 7.434 2.927 5.055c.377.66.068 1.193-.686 1.193zM10 16a1.21 1.21 0 01-1.187-1.25c0-.775.555-1.287 1.193-1.287.68 0 1.193.512 1.193 1.287 0 .714-.457 1.26-1.18 1.26H10V16zm-.91-3.33l-.25-6.11h2.32l-.25 6.11H9.09z",
    fill: "#010101",
    fillRule: "nonzero"
  })));
}
export default SvgWarningHorse;